<app-skill-builder-select-list
	[mainTitle]="page.title"
	[subTitle]="subTitle"
	[options]="options"
	[next]="next"
>
</app-skill-builder-select-list>
